/**
 *  AnimatedNumber script file
**/
import filters from '@/filters/customFormatters'

export default {
  name: 'AnimatedNumber',
  mixins: [filters],
  components: {},
  props: {
    number: {
      type: Number,
      default: 0,
      required: false
    },
    velocity: {
      type: Number,
      default: 10,
      required: false
    },
    format: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      display: 0,
      interval: false
    }
  },
  mounted () {
    this.display = this.number
  },
  computed: {
    displayIsNumber () {
      return typeof this.display === 'number'
    }
  },
  methods: {
  },
  watch: {
    number () {
      clearInterval(this.interval)
      if (this.number === this.display) {
        return
      }
      this.interval = window.setInterval(() => {
        if (this.display === this.number) {
          clearInterval(this.interval)
          return
        }
        let change = (this.number - this.display) / 20
        change = change >= 0 ? Math.ceil(change) : Math.floor(change)
        this.display += change
      }, this.velocity)
    }
  }
}
